// Inscripción guarda la clave de la licenciatura; reinscripción, el nombre. '' = sin licenciatura
export const LICENCIATURAS_INSCRIPCION = [
    { valor: 'cine', etiqueta: 'Cine Digital' },
    { valor: 'animacion', etiqueta: 'Animación' },
    { valor: 'multimedia', etiqueta: 'Multimedia' },
    { valor: 'marketing', etiqueta: 'Marketing Digital' },
    { valor: '', etiqueta: 'Sin licenciatura' }
];

export const LICENCIATURAS_REINSCRIPCION = [
    { valor: 'Cine', etiqueta: 'Cine Digital' },
    { valor: 'Animación', etiqueta: 'Animación' },
    { valor: 'Multimedia', etiqueta: 'Multimedia' },
    { valor: 'Marketing', etiqueta: 'Marketing Digital' },
    { valor: 'Publicidad', etiqueta: 'Publicidad' },
    { valor: '', etiqueta: 'Sin licenciatura' }
];

// Índice que usa la API: 0 ene-abr, 1 may-ago, 2 sep-dic
export const CUATRIMESTRES = ['Enero – Abril', 'Mayo – Agosto', 'Septiembre – Diciembre'];

export const etiquetaLicenciatura = (licenciaturas, valor) => licenciaturas.find(l => l.valor === (valor ?? ''))?.etiqueta ?? valor;

const ZONA = 'America/Mexico_City';

export const formatearFecha = fecha => (fecha ? new Date(fecha).toLocaleDateString('es-MX', { day: 'numeric', month: 'short', year: 'numeric', timeZone: ZONA }) : '');

export const formatearFechaHora = fecha => (fecha ? new Date(fecha).toLocaleString('es-MX', { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: ZONA }) : '');

// Celular mexicano de 10 dígitos → enlace de WhatsApp con 52; otro formato se usa tal cual
export const enlaceWhatsapp = celular => {
    const digitos = String(celular ?? '').replace(/\D/g, '');
    if (!digitos) return null;
    return 'https://wa.me/' + (digitos.length === 10 ? '52' + digitos : digitos);
};
